import React from 'react';

import Skeleton from './Skeleton';

/**
 * Per-widget loading placeholder, shown inside each real card while that card's
 * data loads — i.e. after the view's definitions have resolved and the canvas
 * has rendered. (Until definitions resolve, the whole canvas shows a single
 * CanvasLoading, so there is no separate gate-skeleton phase.)
 *
 * Every gadget renders the same plain card rather than a shape-matched skeleton:
 * one steady plain card per tile is calmer than a wall of differing shapes.
 */
const CardSkeleton = () => <Skeleton height="100%" borderRadius={6} />;

export default CardSkeleton;
